export default __webpack_public_path__ + "static/media/home-internet-delivery.2c95d9b8.jpg";